export const formatDateTime = (dateString, timeZone) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  //We check the timezone
  if (!timeZone) {
    const pad = (n) => n.toString().padStart(2, '0');

    const day = pad(date.getUTCDate());
    const month = pad(date.getUTCMonth() + 1);
    const year = date.getUTCFullYear();

    let hours = date.getUTCHours();
    const minutes = pad(date.getUTCMinutes());

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convierte 0 a 12 para formato 12h
    hours = pad(hours);

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  } else {
    // scheduled_timezone may be an IANA zone ("America/Panama") or a locale ("es-PA")
    const options = { dateStyle: "short", timeStyle: "short" };
    try {
      return date.toLocaleString("es", { ...options, timeZone });
    } catch (e) {
      try {
        return date.toLocaleString(timeZone, options);
      } catch (e2) {
        return date.toLocaleString("es", options);
      }
    }
  }

};
